import { selectRequestParams } from 'data/selectors'
import { getDateKey } from 'data/utils'
import { moment } from 'locale'
import { connect } from 'react-redux'
import { toggleMenu } from 'store/actions'
import { UPDATE_LAST_REFETCH_TIME } from 'store/reducers/lastReFetchTime'
import type { State } from 'store/types'

import AppHeader from './AppHeader'

const mapStateToProps = (state: State) => {
  const requestParams = selectRequestParams(state)
  const { dateCurrent } = state.datePicker
  const timestamp = state.group[getDateKey(requestParams, true)]?.data?.timestamp
  const fetchTime = timestamp ? moment(timestamp) : null

  return {
    fetchTime,
    selectedDate: dateCurrent,
  }
}

const refreshData = () => ({ type: UPDATE_LAST_REFETCH_TIME })

export default connect(mapStateToProps, {
  toggleMenu,
  refreshData,
})(AppHeader as any) as any
